var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterIcon = function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.92 2.813c-1.304 0-2.392.92-2.651 2.147H2.625a.563.563 0 0 0 0 1.125h1.643a2.711 2.711 0 0 0 5.28.103h5.827a.562.562 0 1 0 0-1.125H9.591a2.71 2.71 0 0 0-2.67-2.25M5.335 5.526v-.017a1.585 1.585 0 1 1 0 .027zM10.023 10.313c-1.304 0-2.393.92-2.652 2.147H2.625a.562.562 0 1 0 0 1.125h4.746a2.711 2.711 0 0 0 5.304 0h2.717a.563.563 0 0 0 0-1.125h-2.718a2.71 2.71 0 0 0-2.651-2.148m-1.585 2.71a1.585 1.585 0 1 1 3.17 0 1.585 1.585 0 0 1-3.17 0",
    clipRule: "evenodd"
  })));
};
export default SvgFilterIcon;